import { LocalStyles } from "@paperbits/common/styles";

export class SignupSocialModel {
    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
